import { useCallback } from 'react';

import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { useSafePreviousNavigate } from '@sorare/core/src/hooks/useSafePreviousNavigate';

export const useCloseProOnboarding = () => {
  const { generateSportContextPath } = useSportContext();
  const { isIosApp, postMessage } = useIsMobileApp();
  const navigateBack = useSafePreviousNavigate(
    generateSportContextPath(ANY_SPORT_HOME)
  );

  return useCallback(() => {
    if (isIosApp) {
      postMessage('closeCurrentWebview');
      return;
    }

    navigateBack();
  }, [isIosApp, postMessage, navigateBack]);
};
